export const UPLOAD_FILE_TARGET_NAME = 'INTERNAL'
